<div *ngFor="let item of archivosPorTipo">
  <div class="container-cargue-archivo" *ngIf="mostrarComponente(item.tipoAnexo)">
    <app-cargue-archivos
      [precargaArchivos]="item.archivosPreCargados"
      [etiqueta]="isRegistryEmpresa ? item.tipoAnexo.nombreAnexo! : item.tipoAnexo.etiquetaAnexo!"
      [tamanioMin]="item.tipoAnexo.tipoAnexo?.tamanoMin!"
      [descripcionRegla]="item.tipoAnexo.tipoAnexo?.descripcionRegla"
      [extensiones]="item.tipoAnexo.tipoAnexo?.extensiones!"
      [reglaArchivo]="item.tipoAnexo.tipoAnexo?.reglaArchivo!"
      [tamanioMax]="item.tipoAnexo.tipoAnexo?.tamanoMax!"
      [requerido]="item.tipoAnexo.requerido!"
      (cargar)="cargar(item.tipoAnexo, $event)"
      [urlGuia]="item.tipoAnexo.url"
      [documentoGuia]="item.tipoAnexo.documentoGuia"
      (eliminar)="eliminar(item.tipoAnexo, $event)"
      [cantidadMaxAchivos]="cantidadMaxAchivos"/>
  </div>
</div>
<span class="alert-carga-de-archivo-govco">{{ textoAdvertencia }}</span>
<div class="col-12 d-flex justify-content-end" *ngIf="btnEnviar">
  <button
    type="button"
    class="btn-govco fill-btn-govco"
    (click)="guardar()"
    [disabled]="idTramite === 0 || idTramite == null"
    [attr.aria-label]="etiquetaBoton">
    {{ etiquetaBoton }}
  </button>
</div>
